<template>
  <div>

    <el-drawer :with-header="false" :visible.sync="create.show" size="550px">
      <el-header class="el-header">
        <div>新建设备</div>
      </el-header>

      <el-main class="el-main">
        <div class="main-content">
          <el-form class="drawer-form" size="mini">
            <el-form-item prop="name" label="设备名称" label-width="100">
              <el-input v-model="create.form.name"></el-input>
            </el-form-item>
            <el-form-item prop="licenseCode" label="授权码" label-width="100">
              <el-input v-model="create.form.licenseCode"
                        placeholder="平台总后台分配给本企业的设备授权码（选填）"></el-input>
            </el-form-item>
            <el-form-item prop="areaId" label="区域">
              <el-select v-model="create.form.areaName" :popper-append-to-body="false" value-key="id" clearable>
                <el-option :value="create.selectTree" class="option-style" disabled
                           :key="create.selectTree.id" :label="create.selectTree.name">
                  <el-tree style="min-height: 150px; max-height: 300px" :data="customerList" :props="defaultProps"
                           ref="tree"
                           check-strictly :expand-on-click-node="false"
                           @node-click="(data, node, item) => nodeClickinCreate(data, node, item)"></el-tree>
                </el-option>
              </el-select>

            </el-form-item>
            <el-form-item prop="category" label="设备分类">
              <!--              <el-input v-model="create.form.category" disabled></el-input>-->
              <el-select v-model="create.form.category" size="mini" clearable disabled>
                <el-option v-for="item in deviceCategoryList" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="type" label="设备类型">
              <el-select v-model="create.form.type" size="mini" clearable>
                <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="areaAuthId" label="区域授权">
              <el-select v-model="create.form.areaAuthId" size="mini" clearable>
                <el-option v-for="item in areaAuthList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-main>

      <el-footer>
        <div class="footer-content">
          <el-button size="mini" type="primary" @click="onCreateDeviceClick" :disabled="!hasCommitPermission">创建
          </el-button>
          <el-button size="mini" @click="create.show = false">返回</el-button>
        </div>
      </el-footer>
    </el-drawer>

    <div class="manage-table">
      <el-form :inline="true" :model="formSearch" size="mini" class="demo-form-inline">
        <div>
          <span class="top-title">设备总数</span>
          <span class="top-content"> {{ totalDeviceCount }} </span>
          <span class="top-title">当前在线</span>
          <span class="top-content"> {{ onlineDeviceCount }} </span>
          <span class="top-content"></span>
        </div>
        <br>
        <el-form-item label="区域">
          <el-select v-model="formSearch.area" :popper-append-to-body="false" value-key="id" clearable>
            <el-option :value="selectTree" class="option-style" disabled
                       :key="selectTree.id" :label="selectTree.name">
              <el-tree style="min-height: 150px; max-height: 300px" :data="customerList" :props="defaultProps"
                       ref="tree"
                       check-strictly :expand-on-click-node="false"
                       @node-click="(data, node, item) => addAdminHandleNodeClick(data, node, item)"></el-tree>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备名称">
          <el-input v-model="formSearch.deviceName" placeholder="请输入设备名称"></el-input>
        </el-form-item>


        <el-form-item label="设备类型">
          <el-select v-model="formSearch.deviceType" size="mini" clearable>
            <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="在线状态">
          <el-select v-model="formSearch.onlineState" size="mini" clearable>
            <el-option v-for="item in onLineStateList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="onSearchButtonClick">查询</el-button>
        </el-form-item>
        <br>
        <el-form-item>
          <el-button type="success" @click="onAddButtonClick" :disabled="!hasCommitPermission">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onExportButtonClick">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table stripe class="right-desc" border :data="tableData" size="mini">
        <el-table-column v-for="(headerItem) in mainTableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                         :label="headerItem.label" :width="headerItem.width">
          <template v-slot="scope">
            <template v-if="headerItem.type === 0">{{ scope.row[headerItem.prop] }}</template>
            <template v-else-if="headerItem.type === 1">{{
                scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
              }}
            </template>
            <el-tag v-else-if="headerItem.type === 2">
              {{ scope.row[headerItem.prop] | tableDateFilter(headerItem.prop) }}
            </el-tag>
            <template v-else-if="headerItem.type > 100">
              <el-button v-if="(headerItem.type % 100) & 1" type="primary" size="mini"
                         @click="tableShow(scope.row)">查看
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 2" type="primary" size="mini"
                         @click="tableEdit(scope.row)">操作
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 4" type="danger" size="mini"
                         @click="tableDelete(scope.row)" :disabled="!hasCommitPermission">删除
              </el-button>
            </template>
            <template v-else> {{ scope.row[headerItem.prop] }}</template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px">
          <template v-slot="scope">
            <el-button type="primary" size="mini" @click="tableEdit(scope.row)">操作</el-button>
            <el-button type="danger" size="mini" @click="tableDelete(scope.row)" :disabled="!hasCommitPermission">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination layout="prev, pager, next, jumper" :total="pagiTotal" :page-size="pagiPageSize" :pager-count="5"
                       :current-page.sync="index" @current-change="handlePagination">
        </el-pagination>
      </div>
    </div>

    <el-drawer :with-header="false" :visible.sync="drawerShow" size="550px">
      <el-header class="el-header">
        <div>编辑设备</div>
      </el-header>

      <el-main class="el-main">
        <div class="main-content">
          <el-form class="drawer-form" size="mini" v-model="drawerShowRow">

            <el-form-item label="设备名称：">
              <el-input v-model="drawerShowRow.name"></el-input>
            </el-form-item>
            <el-form-item prop="areaId" label="设备区域：">
              <el-select v-model="drawerShowRow.areaName" :popper-append-to-body="false" value-key="id" clearable>
                <el-option :value="drawerSelectTree" class="option-style" disabled
                           :key="drawerSelectTree.id" :label="drawerSelectTree.name">
                  <el-tree style="min-height: 150px; max-height: 300px" :data="drawerCustomerList" :props="defaultProps"
                           ref="tree"
                           check-strictly :expand-on-click-node="false"
                           @node-click="(data, node, item) => onDrawerNodeClick(data, node, item)"></el-tree>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="设备分类：">
              <el-input v-model="drawerShowRow.category" disabled></el-input>
            </el-form-item>
            <el-form-item label="设备类型：">
              <el-select v-model="drawerShowRow.type" size="mini" clearable>
                <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域授权：">
              <el-select v-model="drawerShowRow.areaAuthId" size="mini" clearable>
                <el-option v-for="item in areaAuthList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备序列号：">
              <el-input v-model="drawerShowRow.hwSn"></el-input>
            </el-form-item>
            <el-form-item label="有线MAC:">
              <el-input v-model="drawerShowRow.limitMac" disabled></el-input>
            </el-form-item>
            <el-form-item label="无线MAC:">
              <el-input v-model="drawerShowRow.wifiMac" disabled></el-input>
            </el-form-item>
            <el-form-item label="设备型号：">
              <el-input v-model="drawerShowRow.model" disabled></el-input>
            </el-form-item>
            <el-form-item label="在线状态：">
              <el-input v-model="drawerShowRow.onlineState" disabled></el-input>
            </el-form-item>
            <el-form-item label="授权码：">
              <el-input v-model="drawerShowRow.licenseCode" disabled></el-input>
            </el-form-item>
            <el-form-item label="创建时间：">
              <el-input v-model="drawerShowRow.createTime" disabled></el-input>
            </el-form-item>
            <el-form-item label="修改时间：">
              <el-input v-model="drawerShowRow.updateTime" disabled></el-input>
            </el-form-item>
            <el-form-item label="上次心跳：">
              <el-input v-model="drawerShowRow.heartbeatTime" disabled></el-input>
            </el-form-item>

          </el-form>
        </div>
      </el-main>

      <el-footer>
        <div class="footer-content">
          <el-button size="mini" @click="drawerShow = false">返回</el-button>
          <el-button size="mini" type="primary" @click="onDrawerSave" :disabled="!hasCommitPermission">保存</el-button>
        </div>
      </el-footer>
    </el-drawer>

  </div>
</template>

<script>

import {mixin_table} from "@/utils/mixin";
import {deviceCreate, deviceDelete, deviceUpdate, getAllArea, getAllDevices, getAllAreaAuth} from "@/api/device-manager-api";
import ExcelJS from "exceljs";

export default {
  name: "EntranceGuardDeviceMgrPage",

  mixins: [mixin_table],

  data() {
    return {
      mountedReadyIndex: 0,

      totalDeviceCount: 0,
      onlineDeviceCount: 0,
      // type 定义：
      // 0，数据不需要处理
      // 1，数据需要过滤，使用 tableDateFilter
      // 2. 数据需要加标签并过滤，使用 tableDateFilter
      // 100. 添加 button ，规则：对100 取余，
      //          结果二进制第1位代表 查看 button， 点击调用 tableShow
      //          结果二进制第2位代表 编辑 button， 点击调用 tableEdit
      //          结果二进制第3位代表 删除 button， 点击调用 tableDelete
      mainTableHeader: [
        {prop: 'name', label: '设备名称', type: 0},
        {prop: 'supAreaName', label: '设备区域', type: 0},
        {prop: 'areaName', label: '设备子区域', type: 0},
        {prop: 'address', label: '设备地址', type: 0},
        {prop: 'category', label: '设备分类', type: 2, width: 95},
        {prop: 'type', label: '设备类型', type: 2, width: 95},
        // {prop: 'model', label: '设备型号', type: 0},
        {prop: 'areaAuthName', label: '区域授权', type: 0},
        {prop: 'onlineState', label: '在线状态', type: 2, width: 70},
        // {prop: 'param99', label: '操作', type: 106},
      ],

      customerList: [],
      defaultProps: {
        children: "areas",
        label: "name",
      },
      selectTree: "",

      deviceCategoryList: [
        {value: "VISITOR_DEVICE", label: "访客设备"},
        {value: "PRINTER_DEVICE", label: "打印机设备"},
        {value: "DOOR_DEVICE", label: "门禁设备"}

      ],

      deviceTypeList: [
        {value: "DOOR_ENTER", label: "入口门禁"},
        {value: "DOOR_LEAVE", label: "出口门禁"},
      ],
      deviceStateList: [
        {value: "VALID", label: "激活"},
        {value: "INVALID", label: "未激活"},
      ],
      onLineStateList: [
        {value: "online", label: "在线"},
        {value: "offline", label: "离线"},
      ],


      formSearch: {
        area: "",
        deviceName: "",
        deviceCategory: "",
        deviceType: "",
        deviceState: "",
        onlineState: "",

        selectAreaNode: null,
      },

      drawerShow: false,
      drawerShowRow: {},
      drawerSelectTree: "",
      drawerCustomerList: [],
      drawerSelectAreaNode: null,

      create: {
        show: false,
        selectTree: "",
        form: {
          name: "",
          licenseCode: "",
          areaId: "",
          areaName: "",
          category: "DOOR_DEVICE",
          type: "",
          areaAuthId: null,
        },
      },

      areaAuthList: [],

      areaInfoMap: {},

    }
  },// data

  mounted() {

    this.getDeviceList()
    this.doGetAllArea()
  },

  methods: {
    doGetAllArea() {
      getAllAreaAuth().then(({data}) => {
        if (data.code === 200) {
          this.areaAuthList = data.data || []
        }
      }).catch(() => {})
      getAllArea().then(({data}) => {
        console.log("getAllArea get data ", data);
        if (data.code === 200) {
          this.customerList = data.data
          this.drawerCustomerList = data.data

          data.data.forEach(item => {
            this.areaInfoMap[item.id] = item
            if (item.areas && item.areas.length > 0) {
              ;(item.areas || []).forEach(subItem => {
                this.areaInfoMap[subItem.id] = subItem
              })
            }
          })

          this.mountedReadyIndex += 1
          this.setAreaInfo()
        } else {
          console.error("getAllArea false", data.msg)
          this.showServerErrMsg(data.code)
        }
      }).catch(err => {
        console.error("getAllArea err ", err)
        this.showNetErrMsg()
      })
    },

    getDeviceList() {
      getAllDevices().then(({data}) => {
        console.log("getAllDevices get data ", data);
        if (data.code === 200) {
          this.tableAllData = data.data.filter(item => {
            return item.category === "DOOR_DEVICE"
          })
          this.tableShowData = this.tableAllData
          this.initPaginationTable()
          this.totalDeviceCount = this.tableAllData.length

          this.mountedReadyIndex += 1
          this.setAreaInfo()
          // 判断当前在线设备梳理
          this.tableAllData.forEach(item => {
            if (!item.hwSn) {
              this.$set(item, 'onlineState', "")
            } else if (item.heartbeatTime == null) {
              this.$set(item, 'onlineState', "offline")
            } else {
              const time = new Date().getTime() - new Date(item.heartbeatTime).getTime()
              if (time > 600 * 1000) {
                this.$set(item, 'onlineState', "offline")
              } else {
                this.$set(item, 'onlineState', "online")
              }
            }

            if (item.onlineState === "online") {
              this.onlineDeviceCount += 1
            }
          })

        } else {
          console.error("getAllWarchDevices false", data.msg)
          this.showServerErrMsg(data.code)
        }
      }).catch(err => {
        console.error("getAllWarchDevices err ", err)
        this.showNetErrMsg()
      })
    },

    setAreaInfo() {
      if (this.mountedReadyIndex < 2) {
        return
      }
      this.tableAllData.forEach(item => {
        this.setOneDeviceAreaInfo(item)
      })
    },

    setOneDeviceAreaInfo(deviceinfo) {
      let areaInfo = this.areaInfoMap[deviceinfo.areaId]
      if (areaInfo) {
        deviceinfo.areaName = areaInfo.name
        if (areaInfo.parentId !== -1) {

          this.$set(deviceinfo, 'subAreaName', areaInfo.name)
          this.$set(deviceinfo, 'subAreaId', areaInfo.id)
          this.$set(deviceinfo, 'address', areaInfo.address)
          let supAreaInfo = this.areaInfoMap[areaInfo.parentId]
          if (supAreaInfo) {
            this.$set(deviceinfo, 'supAreaName', supAreaInfo.name)
            this.$set(deviceinfo, 'supAreaId', supAreaInfo.id)
          }
        } else {
          this.$set(deviceinfo, 'supAreaName', areaInfo.name)
          this.$set(deviceinfo, 'supAreaId', areaInfo.id)
          this.$set(deviceinfo, 'subAreaName', "")
          this.$set(deviceinfo, 'subAreaId', "")
          this.$set(deviceinfo, 'address', "")

        }
      }
    },

    onCreateDeviceClick() {
      if (this.create.form.name === "") {
        this.$message({message: '请输入设备名称', type: 'warning'});
        return
      }
      if (this.create.form.areaId === "") {
        this.$message({message: '请选择区域', type: 'warning'});
        return
      }
      // 授权码选填：填了走总后台授权码绑定（门禁编号配授权码即可通行）
      let licenseCode = (this.create.form.licenseCode || "").trim().toUpperCase()
      let postData = {
        name: this.create.form.name,
        licenseCode: licenseCode || undefined,
        areaId: this.create.form.areaId,
        category: this.create.form.category,
        type: this.create.form.type,
        areaAuthId: this.create.form.areaAuthId,
      }
      deviceCreate(postData).then(({data}) => {
        console.log("deviceCreate get data ", data);
        if (data.code === 200) {
          this.create.show = false
          this.setOneDeviceAreaInfo(data.data)
          this.$message({message: '创建成功', type: 'success'});
          this.tableAllData.push(data.data)
          this.tableShowData = this.tableAllData
          this.initPaginationTable()
        } else {
          console.error("deviceCreate false", data.msg)
          this.showServerErrMsg(data.code)
        }
      }).catch(err => {
        console.error("deviceCreate err ", err)
        this.showNetErrMsg()
      })
    },


    nodeClickinCreate(e) {
      console.log(e);
      this.create.form.areaId = e.id
      this.create.form.areaName = e.name
      this.create.selectTree = e
    },

    addAdminHandleNodeClick(e) {
      console.log(e);
      this.formSearch.area = e.name
      this.formSearch.selectAreaNode = e
    },
    onDrawerNodeClick(e) {
      console.log(e);
      this.drawerShowRow.areaName = e.name
      this.drawerSelectAreaNode = e
      this.drawerSelectTree = e
    },


    tableShow(row) {
      console.log(row);
    },

    tableEdit(row) {
      this.refreshAreaAuthList()

      console.log(row);
      // 一次性整体赋值：Vue2 对已观察对象补赋的键不是响应式的，
      // 逐字段赋值会导致下拉 v-model 选中后界面不更新（看起来"点了没反应"）
      this.drawerShowRow = {
        id: row.id,
        originName: row.name,
        name: row.name,
        areaId: row.areaId,
        areaName: row.areaName,
        category: this.$options.filters.tableDateFilter(row.category, 'category'),
        originType: row.type,
        type: row.type,
        model: row.model,
        originSn: row.hwSn,
        hwSn: row.hwSn,
        wifiMac: row.wifiMac,
        limitMac: row.limitMac,
        active: this.$options.filters.tableDateFilter(row.active, 'active'),
        onlineState: row.onlineState,
        originAreaAuthId: row.areaAuthId,
        areaAuthId: row.areaAuthId,
        code: row.code,
        licenseCode: row.licenseCode,
        createTime: this.$options.filters.timeFilter(row.createTime),
        updateTime: this.$options.filters.timeFilter(row.updateTime),
        heartbeatTime: this.$options.filters.timeFilter(row.heartbeatTime),
      }
      // 设备的 areaId 可能已不在区域树（区域被删/存量悬空数据），回落空串避免抽屉渲染崩溃
      this.drawerSelectTree = this.areaInfoMap[row.areaId] || ""
      this.drawerShow = true
    },

    findInListAndDelById(tableList, id) {
      let len = tableList.length;
      for (let i = 0; i < len; i++) {
        if (tableList[i].id === id) {
          console.log("to del index " + i)
          tableList.splice(i, 1)
          break;
        }
      }
    },

    tableDelete(row) {
      console.log("tableDelete", row.name);

      deviceDelete(row.id).then(({data}) => {
        console.log("tableDelete get data ", data);

        if (data.code === 200) {
          this.findInListAndDelById(this.tableData, row.id)
          this.findInListAndDelById(this.tableShowData, row.id)
          this.findInListAndDelById(this.tableAllData, row.id)

        } else {
          console.error("getAllWarchDevices false", data.msg)
          this.showServerErrMsg(data.code)
        }
      }).catch(err => {
        console.error("getAllWarchDevices err ", err)
        this.showNetErrMsg()
      })
    },
    onSearchButtonClick() {
      let formSearch = this.formSearch
      if (formSearch.area || formSearch.deviceType || formSearch.deviceName || formSearch.deviceState ||
          formSearch.deviceCategory || formSearch.onlineState) {
        let filter = this.tableAllData.filter(item => {
          if (formSearch.area && item.areaName !== formSearch.area) {
            return false
          }
          if (formSearch.deviceCategory && item.category !== formSearch.deviceCategory) {
            return false
          }
          if (formSearch.deviceType && item.type !== formSearch.deviceType) {
            return false
          }
          if (formSearch.deviceState && item.active !== formSearch.deviceState) {
            return false
          }
          if (formSearch.onlineState && item.onlineState !== formSearch.onlineState) {
            return false
          }
          if (formSearch.deviceName && !item.name.includes(formSearch.deviceName)) {
            return false
          }
          return true
        });
        this.tableShowData = filter
        this.initPaginationTable()
      } else {
        this.tableShowData = this.tableAllData
        this.initPaginationTable()
      }
    },

    // 打开抽屉时刷新区域授权列表（授权可在别处新建，避免下拉看到旧数据/空列表）
    refreshAreaAuthList() {
      getAllAreaAuth().then(({data}) => {
        if (data.code === 200) {
          this.areaAuthList = data.data || []
        }
      }).catch(() => {})
    },

    onAddButtonClick() {
      this.create.show = true
      this.refreshAreaAuthList()
      this.create.form.name = ""
      this.create.form.licenseCode = ""
      this.create.form.areaId = ""
      this.create.form.areaName = ""
      this.create.selectTree = ""
    },

    async onExportButtonClick() {
      const header = ['设备名称', '区域', '地区', '设备分类', '设备类型', '设备型号', '设备序列号', '在线状态']
      const columnsSize = header.length
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Sheet1');
      sheet.addRow(header);
      const firstRow = sheet.getRow(1);
      firstRow.eachCell((cell, colNumber) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'FFD9D9D9'},
          bgColor: {argb: 'FFD9D9D9'}
        };
        cell.font = {
          size: 12,
          bold: true
        };
      });
      firstRow.height = 20;
      for (let i = 0; i < columnsSize; i++) {
        sheet.getColumn(i + 1).width = 20;
      }

      this.tableAllData.forEach(item => {
        let name = item.name
        let supAreaName = item.supAreaName
        let subAreaName = item.subAreaName
        let category = this.$options.filters.tableDateFilter(item.category, 'category')
        let type = this.$options.filters.tableDateFilter(item.type, 'type')
        let model = item.model
        let hwSn = item.hwSn
        let onlineState = this.$options.filters.tableDateFilter(item.onlineState, 'onlineState')

        let row = [name, supAreaName, subAreaName, category, type, model, hwSn, onlineState]
        sheet.addRow(row)
      })

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});


      let link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = '设备列表.xlsx';

      link.click();

      URL.revokeObjectURL(link.href);
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    onDrawerSave() {
      let areaChange = false
      let nameChange = false
      let typeChange = false
      let snChange = false
      let authChange = false
      if (this.drawerSelectAreaNode && this.drawerSelectAreaNode.id !== this.drawerShowRow.areaId) {
        console.log("areaChange")
        areaChange = true
      }
      if (this.drawerShowRow.name !== this.drawerShowRow.originName) {
        console.log("nameChange")
        nameChange = true
      }
      if (this.drawerShowRow.originType !== this.drawerShowRow.type) {
        console.log("typeChange")
        typeChange = true
      }
      if (this.drawerShowRow.hwSn !== this.drawerShowRow.originSn) {
        console.log("snChange")
        snChange = true
      }
      if (this.drawerShowRow.originAreaAuthId !== this.drawerShowRow.areaAuthId) {
        console.log("authChange")
        authChange = true
      }
      if (!areaChange && !nameChange && !typeChange && !snChange && !authChange) {
        this.$message({message: '设备未修改', type: 'warning'});
        return
      }
      if (this.drawerShowRow.name === "") {
        this.$message({message: '请输入设备名称', type: 'warning'});
        return
      }
      let postData = {
        id: this.drawerShowRow.id,
        name: this.drawerShowRow.name,
      }
      if (areaChange) {
        postData.areaId = this.drawerSelectAreaNode.id
      }
      if (typeChange) {
        postData.type = this.drawerShowRow.type
      }
      if (snChange) {
        postData.hwSn = this.drawerShowRow.hwSn
      }
      if (authChange) {
        postData.areaAuthId = this.drawerShowRow.areaAuthId
      }

      console.log("deviceUpdate postData ", postData);
      deviceUpdate(postData).then(({data}) => {
        console.log("deviceUpdate get data ", data);
        if (data.code === 200) {
          this.drawerShow = false
          this.$message({message: '修改成功', type: 'success'});
          this.getDeviceList()
        } else {
          console.error("updateDeviceArea false", data.msg)
          this.showServerErrMsg(data.code)
        }
      }).catch(err => {
        console.error("updateDeviceArea err ", err)
        this.showNetErrMsg()
      })
      this.drawerShow = false
    },

  },// method
  filters: {
    tableDateFilter(value, prop) {
      if (prop === 'category') {
        switch (value) {
          case 'VISITOR_DEVICE':
            return "访客设备"
          case 'PRINTER_DEVICE':
            return '打印机设备'
          case "DOOR_DEVICE":
            return '门禁设备'
          default:
            return ""
        }
      } else if (prop === 'type') {
        switch (value) {
          case 'SOFTWARE':
            return "软件设备"
          case 'ADAPTER':
            return '硬件适配设备'
          case 'INTEGRATE':
            return '一体设备'
          case 'DOOR_ENTER':
            return '入口门禁'
          case 'DOOR_LEAVE':
            return '出口门禁'
          default:
            return ""
        }
      } else if (prop === 'active') {
        switch (value) {
          case 'VALID':
            return "激活"
          case 'INVALID':
            return '未激活'
          default:
            return ""
        }
      } else if (prop === 'onlineState') {
        switch (value) {
          case 'online':
            return "在线"
          case 'offline':
            return '离线'
          default:
            return ""
        }
      }
      return value
    },
    timeFilter(value) {
      if (value == null || value.length < 19) {
        return value
      } else {
        return value.substring(0, 10) + " " + value.substring(11, 19)
      }
    },
  },
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("DEVICE_MANAGE_MODIFY")
        default:
          return false
      }
    }
  },
}
</script>


<style scoped lang="less">
.manage-table {

  .right-desc {
    /deep/ .el-table__body-wrapper {
      min-height: calc(100vh - 400px);
      // height: 700px;
    }

    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      /*width: 0;宽度为0隐藏*/
      width: 0px;
    }
  }
}

.manage-table > .demo-form-inline {
  margin-bottom: 20px;
}

.option-style {
  overflow: auto;
  height: 100%;
}

.top-title {
  display: inline;
  height: 28px;
  line-height: 28px;
  font-weight: 600;
  font-size: 16px;
}

.top-content {
  height: 28px;
  line-height: 28px;
  font-size: 16px;
  margin-left: 8px;
  margin-right: 12px;
}

.dialog-select-box {
  margin-top: 10px;
  width: 100%;
  text-align: center;
}

.el-main > .main-content > .drawer-form > .el-form-item {
  display: flex;
  justify-content: flex-start;

  /deep/ .el-form-item__label {
    width: 100px;
  }

  /deep/ .el-input {
    width: calc(20vw);
  }
}

.el-footer {
  text-align: center;
  line-height: 60px;
}

.el-header {
  text-align: center;
  line-height: 60px;
}

.el-main {
  height: calc(100% - 120px);
  padding: 0;
}

</style>
